import React from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';

import EsmsDialog from '../../components/EsmsDialog';

import * as UiActions from '../../actions/uiActions';

import classes from './RefreshInventorySettingsModal.module.css';

const ValidationSchema = Yup.object().shape({
    dynamicStartingPath: Yup.string(),
    dynamicEndingPath:   Yup.string()
});

const RefreshNiagaraInventorySettingsModal = ({
    clearErrors,
    errors,
    handleRefreshInventory,
    handleSelectedAgentRoute,
    isLoading,
    onClose,
    open,
    title,
    toggleLoading,
    triggerInventoryScan,
    ...props
}) => {
    const formik = useFormik({
        initialValues: {
            dynamicStartingPath: '',
            dynamicEndingPath:   ''
        },
        validationSchema: ValidationSchema,
        onSubmit:         async (values, { setSubmitting }) => {
            setSubmitting(true);

            const path = {
                basePath:    'config/' + values.dynamicStartingPath,
                partialPath: values.dynamicEndingPath ? 'config/' + values.dynamicStartingPath + '/' + values.dynamicEndingPath : ''
            };

            try {
                if (!isLoading) {
                    toggleLoading(true);
                    handleRefreshInventory(false, path);
                    handleClose();
                    handleSelectedAgentRoute();
                }
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    const handleClose = () => {
        toggleLoading(false);
        onClose();
    };

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            title={title}
            onConfirm={formik.handleSubmit}
            onRendered={formik.handleReset}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
            confirmText="Refresh"
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/basAgentIconColor.svg" alt="settings icon" />
                        <span>Refresh Inventory Settings</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            Click refresh to kick off a scan of BAS. This will be performed in the background and may take a few minutes.
                        </p>
                        <p>
                            If you'd like to narrow the range of scanning change the scan starting oBIX path, otherwise leave the default.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormLabel className={classes.formLabel}>Scan oBIX Path</FormLabel>
                        <FormControl className={classes.path}>
                            <InputLabel className={formik.errors.dynamicPath && classes.errors}>Starting Obix Path</InputLabel>
                            <Input
                                className={formik.errors.dynamicPath ? `${classes.errors} ${classes.cssErrorUnderline} ${classes.DynamicPath}` : classes.DynamicPath}
                                name="dynamicStartingPath"
                                value={formik.values.dynamicStartingPath}
                                onChange={formik.handleChange}
                                startAdornment={<InputAdornment className={classes.Adornment} position="start">config/</InputAdornment>}
                            />
                            {
                                formik.errors.dynamicPath && 
                                    <FormHelperText className={classes.errors}>
                                        {formik.errors.dynamicPath}
                                    </FormHelperText>
                            }
                        </FormControl>
                        <FormControl>
                            <InputLabel className={formik.errors.dynamicPath && classes.errors}>Ending Obix Path</InputLabel>
                            <Input
                                className={formik.errors.dynamicPath ? `${classes.errors} ${classes.cssErrorUnderline} ${classes.DynamicPath}` : classes.DynamicPath}
                                name="dynamicEndingPath"
                                value={formik.values.dynamicEndingPath}
                                onChange={formik.handleChange}
                                startAdornment={<InputAdornment className={classes.Adornment} position="start">{formik.values.dynamicStartingPath ? `config/${formik.values.dynamicStartingPath}/` : 'config/'}</InputAdornment>}
                            />
                            {
                                formik.errors.dynamicPath &&
                                <FormHelperText className={classes.errors}>
                                    {formik.errors.dynamicPath}
                                </FormHelperText>
                            }
                        </FormControl>
                    </div>
                </div>
            </div>
        </EsmsDialog>
    );
};

RefreshNiagaraInventorySettingsModal.defaultProps = {
    open:                     false,
    onClose:                  () => {},
    handleRefreshInventory:   () => {},
    handleSelectedAgentRoute: () => {},
    isLoading:                false,
    title:                    ''
};

RefreshNiagaraInventorySettingsModal.propTypes = {
    onClose:                  func.isRequired,
    open:                     bool.isRequired,
    handleRefreshInventory:   func.isRequired,
    handleSelectedAgentRoute: func.isRequired,
    isLoading:                bool.isRequired,
    title:                    string.isRequired
};

const mapStateToProps = state => {
    return {
        isLoading: state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(RefreshNiagaraInventorySettingsModal);

